import React from "react";
import BaseAvailabilityCheckbox from "./BaseAvailabilityCheckbox";

export default function ReadOnlyAvailabilityCheckbox({ checked, disabled, overridden }) {
  return (
    <BaseAvailabilityCheckbox interactive={false} overridden={overridden}>
      <input checked={checked} disabled={disabled} onChange={() => {}} type="checkbox" />
      <label aria-label="Availability" htmlFor="checkbox" role="presentation" />
    </BaseAvailabilityCheckbox>
  );
}
